export function addressFieldDisplay(country) {
  let state_string = 'Administrative Area';
  let zip_string = 'Postal Code';
  let city_string = 'Locality';
  let address_string = 'Street';
  let apartment_string = 'Apartment';
  if (country === 'AU') {
    state_string = 'State';
    city_string = 'City';
    zip_string = 'Post Code';
    apartment_string = 'Unit/Apt';
  }
  return {state_string, city_string, zip_string, address_string, apartment_string};
};
